const _ = require('lodash');

function get(key) {
    return _.get(_.get(window, "globalConfig.validation.patterns", {phoneBasic: /(^(\+\d{1,2}\s)?((\(\d{3}\))|\d{3})[\s\.\-]?\d{3}[\s\.\-]?\d{4}$)|^$/}), key);
}

export const patterns = {
    poBox: /(?:P(?:ost(?:al)?)?[\.\-\s]*(?:(?:O(?:ffice)?[\.\-\s]*)?B(?:ox|in|\b|\d)|o(?:ffice|\b)(?:[-\s]*\d)|code)|box[-\s\b]*\d)/i,
    address() { return get("address"); },
    tollFreeNumbers(){return get("tollFreeNumber")},
    validPhone(){return get("phoneBasic")},
    validPhoneWithoutTollFreeAsString(){return get("phone").toString().slice(1,-1)},
    validEmail(){return get("email")}
};
